<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'联系客服' | dealLanguage('Contact Us')}}</page-header>
    <div class="contact-wrapper">
      <div class="top-tip" v-if="language == 'zh'"><span>2025VBEF展会</span>信息一键触达！如需任何咨询或了解更多详情，请扫描下方二维码添加专属客服。</div>
      <div class="top-tip" v-if="language == 'en'"><span>2025VBEF exhibition</span> information can be easily accessed with just one click! If you need any consultation or more details, please scan the QR code below to add a dedicated customer service representative.</div>
      <div class="qrlist">
        <div class="qritem">
          <div class="title">参展&参会咨询</div>
          <img :src="static_img_url + 'pic/contactUs/li.jpg'" class="qr-img" />
          <p class="p1">李女士<br><br>18600921680</p>
        </div>
        <div class="qritem">
          <img :src="static_img_url + 'pic/contactUs/ren.jpg'" class="qr-img" />
          <p class="p1">任女士<br><br>15111945514</p>
        </div>
        <div class="qritem">
          <img :src="static_img_url + 'pic/contactUs/yang.jpg'" class="qr-img" />
          <p class="p1">杨先生<br><br>15360825131</p>
        </div>
        <div class="qritem">
          <div class="title">媒体及商务合作</div>
          <img :src="static_img_url + 'pic/contactUs/tan.jpg'" class="qr-img" />
          <p class="p1">覃女士<br><br>19332194206</p>
        </div>
        <div class="qritem">
          <div class="title">参会报名</div>
          <img :src="static_img_url + 'pic/contactUs/huang.jpg'" class="qr-img" />
          <p class="p1">黄女士<br><br>13801260803</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('联系客服', 'Contact Us'),
    }
  },
  inject: ['wxShare'],
  components: {
    PageHeader,
  },
  created() {},
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('联系客服-CSGCT', 'Contact Us-CSGCT'),
      linkurl: this.vbef_path + '/contactUs',
    })
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
  },
  methods: {},
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
.contact-wrapper
  padding 0.3rem 0.4rem 0.6rem
  .top-tip
    font-size 0.26rem
    color #3D3D3D
    line-height 0.42rem
    text-align justify
    span
      color #C8161D
  .qrlist
    margin-top 0.43rem
    .qritem
      position relative
      display flex
      flex-wrap wrap
      align-items: center
      &+.qritem
        margin-top: .3rem
      .title
        line-height 0.36rem
        padding-left 0.1rem
        border-left 0.04rem solid #C8161D
        font-weight 600
        font-size 0.26rem
        color #3D3D3D
        white-space nowrap
        width 100%
        margin-bottom 0.3rem
      .qr-img
        width 2rem
        height 2rem
        display block
        margin-right 0.28rem
      .p1
        font-size 0.28rem
        line-height 1
        color #333333
</style>